
import HeavenItem from './HeavenItem';

class HiCloud extends HeavenItem {
  constructor(parentCont, data) {
    super(data);

    // vars
    this.parentCont = parentCont;
    // parts
    this.sprite = null;

    // init
    this.init();
  }

  // --------------------------------------------------------------
  // Init
  // --------------------------------------------------------------

  init() {
    // parts
    this.setSprite(this.data.type.split('_')[0].replace('c', ''));
  }

  setSprite(spriteId) {
    this.sprite = new PIXI.Sprite.fromFrame(`cloud-${spriteId}.png`);
    this.parentCont.addChild(this.sprite);
  }

  // --------------------------------------------------------------
  // Loop
  // --------------------------------------------------------------

  loopUp() {
    super.loopUp();
    this.sprite.x = this.position.item.x;
    this.sprite.y = this.position.item.y;
  }
}

export default HiCloud;



// WEBPACK FOOTER //
// ./src/js/scene/parts/heaven/parts/HiCloud.js